import { h } from "preact";
import './timeline-styles.scss'
import Message from './Message'
import { ButtonGhost } from '../../../_common/components/buttons/buttons'
import ModalNewMessage from './ModalNewMessage'
import { useState } from 'preact/hooks'
import { useSelector } from 'react-redux'
import { t } from '../../../_i18n'

export default function Timeline () {
  const [openModal, setOpenModal] = useState(false);
  const messages = useSelector(state => state.fct.messages);
  const formativeZoneCode = useSelector(state => state.status.student_meta.formative_zone_code);
  const conditionFormativeZoneCode = (formativeZoneCode.toUpperCase() === 'CAT2425' || formativeZoneCode.toUpperCase() === 'MAD2425');


    return (
    <div className='fct-timeline'>
      <p className='font-32'>{t('Comentarios')}</p>
      <ModalNewMessage visible={openModal} onClose={() => setOpenModal(false)} />
      <ButtonGhost className='m-top button' onClick={() => setOpenModal(true)}>{t('Añadir comentario nuevo')}</ButtonGhost>
      {messages.map(({ id, type, content, message_direction, send_at, attached_docs }) =>
          <Message id={id}
                   type={type}
                   title={
                     type === 'event'
                         ? content
                         : message_direction === 'received'
                             ? t('Gestor de practicas')
                             : t('Yo')
                   }
                    date={send_at}
                   body={type === 'message' && content}
                   attached={attached_docs}
          />)
      }
    </div>
  )
}
